import { useEffect } from "react";

const COLORS = ["#00F0FF", "#F0C971", "#ff4dd8", "#c66bff", "#3dff8f", "#ffffff"];

export const SparkleFX = () => {
  useEffect(() => {
    let lastMove = 0;
    let lastScroll = 0;
    let lastHover = 0;

    const spawn = (x, y, big = false) => {
      const s = document.createElement("span");
      s.className = "fx-sparkle";
      const size = big ? 9 + Math.random() * 10 : 4 + Math.random() * 7;
      const color = COLORS[Math.floor(Math.random() * COLORS.length)];
      s.style.cssText = `left:${x - size / 2}px;top:${y - size / 2}px;width:${size}px;height:${size}px;background:${color};color:${color}`;
      document.body.appendChild(s);
      setTimeout(() => s.remove(), 950);
    };

    const onMove = (e) => {
      const now = performance.now();
      if (now - lastMove < 45) return;
      lastMove = now;
      spawn(e.clientX + Math.random() * 24 - 12, e.clientY + Math.random() * 24 - 12);
    };

    const onScroll = () => {
      const now = performance.now();
      if (now - lastScroll < 650) return;
      lastScroll = now;
      for (let i = 0; i < 14; i++) {
        setTimeout(() => {
          spawn(
            window.innerWidth * (i / 13) + Math.random() * 40 - 20,
            window.innerHeight * (0.15 + Math.random() * 0.7),
            true
          );
        }, i * 55);
      }
    };

    const onOver = (e) => {
      const el = e.target.closest("a, button");
      if (!el) return;
      const now = performance.now();
      if (now - lastHover < 300) return;
      lastHover = now;
      const r = el.getBoundingClientRect();
      for (let i = 0; i < 6; i++) {
        setTimeout(() => {
          spawn(r.left + Math.random() * r.width, r.top + Math.random() * r.height);
        }, i * 40);
      }
    };

    window.addEventListener("mousemove", onMove, { passive: true });
    window.addEventListener("scroll", onScroll, { passive: true });
    document.addEventListener("mouseover", onOver, { passive: true });
    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("scroll", onScroll);
      document.removeEventListener("mouseover", onOver);
    };
  }, []);

  return null;
};
